import React, { useState, createContext, useContext } from 'react';
type Theme = 'light' | 'dark' | 'platinum';
interface ThemeContextType {
  theme: Theme;
  setTheme: (theme: Theme) => void;
  isDark: boolean;
  isPlatinum: boolean;
}
const ThemeContext = createContext<ThemeContextType | undefined>(undefined);
export function ThemeProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [theme, setTheme] = useState<Theme>('light');
  const isDark = theme === 'dark' || theme === 'platinum';
  const isPlatinum = theme === 'platinum';
  return <ThemeContext.Provider value={{
    theme,
    setTheme,
    isDark,
    isPlatinum
  }} data-id="element-4135" data-mp="ws65btugqr81">
      {children}
    </ThemeContext.Provider>;
}
export function useTheme() {
  const context = useContext(ThemeContext);
  if (context === undefined) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
}